import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function getBpBrands() {
  const res = await axios.get(`${API_BASE}/brand-performance/brands`, { headers: authHeader() });
  return res.data;
}

export async function getBpCohorts(brandId) {
  const res = await axios.get(`${API_BASE}/brand-performance/cohorts/${brandId}`, { headers: authHeader() });
  return res.data;
}

export async function getBpCohortItems(brandId, inboundDates) {
  const res = await axios.get(`${API_BASE}/brand-performance/cohort-items/${brandId}`, {
    headers: authHeader(),
    params: { inbound_dates: inboundDates },
    paramsSerializer: (params) => {
      const sp = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (Array.isArray(v)) v.forEach((x) => sp.append(k, x));
        else if (v != null) sp.append(k, v);
      });
      return sp.toString();
    },
  });
  return res.data;
}

export async function getBpTimeline(brandId, dateFrom, dateTo) {
  const res = await axios.get(`${API_BASE}/brand-performance/timeline/${brandId}`, {
    headers: authHeader(),
    params: { date_from: dateFrom, date_to: dateTo },
  });
  return res.data;
}
